export default "__VITE_ASSET__B40_F3x0__"